// extracted by mini-css-extract-plugin
module.exports = {"TabSwriper2Ph":"TabSwriper2Ph_TabSwriper2Ph__GzzZ7"};